<template>
  <div>         
      <div id="visor_contenedor" v-bind:style="{ 'height': height}">
        <div id="visor" v-bind:style="{ 'height': height}">
          <object v-if="hayUrl || ArchivoAConvertir!=null && EsBlob.esBlob == false" 
          :data="urlPdf" 
          type="application/pdf" 
          v-bind:style="{ 'height': height}"></object>


          <object v-else-if="EsBlob!=undefined && EsBlob.esBlob" 
          :data="urlPdf" 
          type="application/pdf" 
          v-bind:style="{ 'height': height}"></object>
          <label v-else>No hay ruta de archivo. Favor de volver a intentar.</label>          
        </div>
      </div>

  </div>
</template>
<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'
  import axios from 'axios'
  export default {
    data(){
      return {
        enumeraciones,
        hayUrl: true,
        urlPdf: ''
      }
    },
    props: {      
      url: '',
      height: '',
      ArchivoAConvertir: {
        default: null,
        type: File
      },
      EsBase64:{
        esBase64:null,
        archivoBase64:null
      },
      EsBlob:{
        blob:null,
        esBlob:false
      },
      MarcaDeAgua: {
        default: null,
        type: Object // { RutaImagenMarcaDeAgua, TextoMarcaDeAgua }
      }
    },
    created(){  
     // console.log("esbase54:::",this.EsBlob)
      if(this.height == undefined || this .height == '') 
        this.height = this.height;
      if(this.url == undefined || this.url == '')
        this.hayUrl = false
      if(this.EsBlob!= undefined && this.EsBlob.blob!=null && this.EsBlob.esBlob){
       //let objectURL = 
       console.log("EsBlob::",this.EsBlob.blob)
      //let blob = new Blob([this.EsBlob.blob], {type: 'application/pdf'});
      const url = URL.createObjectURL( this.EsBlob.blob );
        console.log("BloB:::",url)
        
          this.urlPdf = url;
       // this.urlPdf = this.EsBlob.blob
      }
      else{
      if(this.EsBase64 != undefined && this.EsBase64.esBase64){
        console.log("EsBase64:::")
    
        const binStr = atob( this.EsBase64.archivoBase64 );
        const len = binStr.length;
        const arr = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
          arr[ i ] = binStr.charCodeAt( i );
        }
        let blob =  new Blob( [ arr ], { type: "application/pdf" } );
        const url = URL.createObjectURL( blob );
        console.log("BloB:::",url)
        
          this.urlPdf = url;//this.EsBase64.archivoBase64;
          this.hayUrl = true
      }else{
      if(this.hayUrl) {
        if(this.MarcaDeAgua != null && this.MarcaDeAgua != undefined) {
          this.ObtenerPdfconMarcaDeAgua();
        }
        else {
          this.ObtenerPdf();
        }
      } 
      else if(this.ArchivoAConvertir != null){ 
        switch(this.ArchivoAConvertir.type) {
            case 'application/msword':
                this.ConvertirArchivoAPdf();
            break;
            case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
                this.ConvertirArchivoAPdf();
            break;
            default:
            var archivoBase64 = "";
           // const base64="";

             // this.urlPdf = URL.createObjectURL(this.ArchivoAConvertir);
              const reader = new FileReader();
              reader.onloadend =  () =>{
                const base64String = reader.result
                .replace('data:', '')
                .replace(/^.+,/, '');
                const binStr = atob( base64String);
                const len = binStr.length;
                const arr = new Uint8Array(len);
                for (let i = 0; i < len; i++) {
                  arr[ i ] = binStr.charCodeAt( i );
                }
                let blob =  new Blob( [ arr ], { type: "application/pdf" } );
                const url = URL.createObjectURL( blob );
        console.log("BloB:::",url)
        
          this.urlPdf = url;//this.EsBase64.archivoBase64;
            
            //    this.urlPdf = base64String
               // console.log( base64String);

          
              };
              reader.readAsDataURL(this.ArchivoAConvertir);
             
            //  console.log( "reader:::",reader.readAsDataURL(this.ArchivoAConvertir));
             // console.log( this.convertBlobToBase64(this.urlPdf));
              break
        }
      }
    }
    }
    },
    methods:{ 

      ObtenerPdf: function (){ 
        console.log("Obtenerpdf::::",this.url)
        let peticionAPI = {
          RutaDelArchivo: this.url
        };
        
        let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false,true);
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.Comun.funcion.ObtenerPdf, peticionAPI)
                .then(respuesta => {            
                    if (respuesta.status != 200) {
                        console.log("error::",respuesta);
                        this.urlPdf = respuesta.data;//URL.createObjectURL(blob);
                       // let mensajeError = respuesta.data.Error.Mensaje;
                       // console.log(mensajeError);
                    } else {
                        
                      //  var blob = new Blob([respuesta.data], {type: 'application/pdf'});
                       // console.log('ocultar::',URL.createObjectURL(blob));
                       const binStr = atob( respuesta.data );
                       const len = binStr.length;
                       const arr = new Uint8Array(len);
                       for (let i = 0; i < len; i++) {
                        arr[ i ] = binStr.charCodeAt( i );
                       }
                       let blob =  new Blob( [ arr ], { type: "application/pdf" } );
                       const url = URL.createObjectURL( blob );
                       console.log("BloB:::",url)
        
                       this.urlPdf = url;//this.EsBase64.archivoBase64;
                       // this.urlPdf = respuesta.data;//URL.createObjectURL(blob);
                       //  console.log('url::',this.urlPdf); 
                    }
                    comun.SeEstaCargandoInformacion(false);
                })
                .catch(excepcion => {
                    comun.SeEstaCargandoInformacion(false);
                    console.log(excepcion);
                }
        );
        comun.SeEstaCargandoInformacion(false);
      },
      ObtenerPdfconMarcaDeAgua: function (){
        let peticionAPI = {
          RutaDelArchivo: this.url,
          RutaImagenMarcaDeAgua: this.MarcaDeAgua.RutaImagenMarcaDeAgua,
          TextoMarcaDeAgua: this.MarcaDeAgua.TextoMarcaDeAgua
        };
        
        let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false,true);
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.Comun.funcion.ObtenerPdfConMarcaDeAgua, peticionAPI)
                .then(respuesta => {            
                    if (respuesta.statusText != "OK") {
                        console.log(respuesta);
                       // let mensajeError = respuesta.data.Error.Mensaje;
                        //console.log(mensajeError);
                    } else {
                        console.log(respuesta);
                        var blob = new Blob([respuesta.data], {type: 'application/pdf'});
                      //  console.log('ocultar::',this.ocultarDescarga);
                        this.urlPdf = URL.createObjectURL(blob);
                        /* console.log('url::',this.urlPdf); */
                    }
                    comun.SeEstaCargandoInformacion(false);
                })
                .catch(excepcion => {
                    comun.SeEstaCargandoInformacion(false);
                    console.log(excepcion);
                }
        );
        comun.SeEstaCargandoInformacion(false);
      },
      ConvertirArchivoAPdf: function (){
        console.log("convertirArchivoAPdf")
        let peticionAPI = new FormData(); 
        peticionAPI.append('Archivo',this.ArchivoAConvertir);
        peticionAPI.append('EsPrueba', false);
        let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal);
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.Comun.funcion.ConvertirAPdf, peticionAPI,headerPeticion)
                .then(respuesta => {  
                  console.log("convertirArchivoAPdf::respuesta::",respuesta)          
                    if (respuesta.status != 200) {
                       // console.log("respuesta:::",respuesta);
                       console.log("respuesta error:::",respuesta)
                       // this.urlPdf = respuesta.data.base64;
                      //  let mensajeError = respuesta.data.Error.Mensaje;
                        //console.log(mensajeError);
                    } else {
                        //console.log("otra",respuesta);
                       // this.urlPdf = respuesta.data.base64;
                        const binStr = atob( respuesta.data.base64 );
                       const len = binStr.length;
                       const arr = new Uint8Array(len);
                       for (let i = 0; i < len; i++) {
                        arr[ i ] = binStr.charCodeAt( i );
                       }
                       let blob =  new Blob( [ arr ], { type: "application/pdf" } );
                       const url = URL.createObjectURL( blob );
                       console.log("BloB:::",url)
        
                       this.urlPdf = url;//this.EsBase64.archivoBase64;
                        //console.log("respuetsa base64:::",this.urlPdf );
                       // var blob = new Blob([respuesta.data], {type: 'application/pdf'});
                       // console.log("blob::::::::::::::::::::::::",blob)
                       // this.urlPdf = URL.createObjectURL(blob);
                       // console.log(this.urlPdf);
                    }
                    comun.SeEstaCargandoInformacion(false);
                })
                .catch(excepcion => {
                    comun.SeEstaCargandoInformacion(false);
                    console.log(excepcion);
                }
        );
        comun.SeEstaCargandoInformacion(false);
      }
    }
  }
</script>
<style> 
  #visor_contenedor {
    flex: 1;
    background: #eee;
    overflow: auto;
  }

  #visor {
    width: 100%;
    margin: 0px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }

  #visor > div {
    text-align: center;
    max-width: 100%;
  }

    #visor object {
      width: 100%;
      box-shadow: 0 2px 5px gray;
    }

    #visor label {
      width: 100%;
      color:black;      
      text-align:center;
    }
</style>



// WEBPACK FOOTER //
// src/components/Comunes/PDFDocument.vue